import 'babel-polyfill';
import 'wicg-inert';
import 'whatwg-fetch';
import './closest';
import './remove';
import './matches';
import './custom-event';
